"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OnDemandTranslationProvider = exports.OnDemandTranslationContext = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _preactCompat = require("preact-compat");

var _OnDemandTranslations = require("@insided/shared/modules/HubAI/OnDemandTranslations");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// Create context with default values
var OnDemandTranslationContext = (0, _preactCompat.createContext)({
  isTranslationInProgress: false,
  selectedLanguageToTranslate: null,
  isTranslationFailed: false,
  isPostTranslated: false,
  translatedTitle: '',
  translatedTopicContent: '',
  translatedBestAnswerText: '',
  translatedPinnedReplyText: '',
  translatedReplies: {},
  languageList: [],
  translatedReply: '',
  onDemandTranslation: function () {
    var _onDemandTranslation = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function onDemandTranslation() {
      return _onDemandTranslation.apply(this, arguments);
    }

    return onDemandTranslation;
  }(),
  onDisplayOriginal: function () {
    var _onDisplayOriginal = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", undefined);

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function onDisplayOriginal() {
      return _onDisplayOriginal.apply(this, arguments);
    }

    return onDisplayOriginal;
  }()
});
exports.OnDemandTranslationContext = OnDemandTranslationContext;

function convertFlatRepliesToOnDemandTranslationPayload(replies) {
  return replies.map(function (reply) {
    return {
      replyContent: reply
    };
  });
}

function convertThreadedRepliesToOnDemandTranslationPayload(replies) {
  return replies.map(function (reply) {
    var _reply$children;

    var childReplies = (_reply$children = reply.children) !== null && _reply$children !== void 0 && _reply$children.result ? convertThreadedRepliesToOnDemandTranslationPayload(reply.children.result) : undefined;
    return {
      replyId: reply.id,
      replyContent: reply.content,
      childReplies: childReplies
    };
  });
}

function convertRepliesToOnDemandTranslationPayload(threadedRepliesEnabled, replies) {
  if (threadedRepliesEnabled) {
    return convertThreadedRepliesToOnDemandTranslationPayload(replies);
  }

  return convertFlatRepliesToOnDemandTranslationPayload(replies);
}

function convertThreadedRepliesToOnDemandTranslationReplies(replies) {
  var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var newResult = _objectSpread({}, result);

  replies.forEach(function (reply) {
    var _reply$children2;

    var id = reply.id,
        content = reply.content;
    newResult[id] = content;
    var childReplies = (_reply$children2 = reply.children) === null || _reply$children2 === void 0 ? void 0 : _reply$children2.result;

    if (childReplies) {
      newResult = convertThreadedRepliesToOnDemandTranslationReplies(childReplies, newResult);
    }
  });
  return newResult;
}

function convertFlatRepliesToOnDemandTranslationReplies(replies) {
  var result = {};
  replies.forEach(function (reply, replyIndex) {
    result[replyIndex] = reply;
  });
  return result;
}

function convertRepliesToOnDemandTranslationReplies(threadedRepliesEnabled, replies) {
  if (threadedRepliesEnabled) {
    return convertThreadedRepliesToOnDemandTranslationReplies(replies);
  }

  return convertFlatRepliesToOnDemandTranslationReplies(replies);
}

function convertResponseRepliesToOnDemandTranslationReplies(response) {
  var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var newResult = _objectSpread({}, result);

  response.forEach(function (responseReply, index) {
    var replyId = responseReply.replyId,
        replyContent = responseReply.replyContent,
        childReplies = responseReply.childReplies;
    var id = replyId !== null && replyId !== void 0 ? replyId : index;
    newResult[id] = replyContent;

    if (childReplies) {
      newResult = convertResponseRepliesToOnDemandTranslationReplies(childReplies, newResult);
    }
  });
  return newResult;
}

var OnDemandTranslationProvider = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(OnDemandTranslationProvider, _Component);

  var _super = _createSuper(OnDemandTranslationProvider);

  function OnDemandTranslationProvider() {
    var _this$props$initialCo, _this$props$initialCo2, _this$props$initialCo3;

    var _this;

    (0, _classCallCheck2.default)(this, OnDemandTranslationProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isTranslationInProgress: false,
      selectedLanguageToTranslate: null,
      isTranslationFailed: false,
      isPostTranslated: false,
      translatedTitle: _this.props.initialContent.title,
      translatedTopicContent: _this.props.initialContent.topicContent,
      translatedBestAnswerText: (_this$props$initialCo = _this.props.initialContent.bestAnswerText) !== null && _this$props$initialCo !== void 0 ? _this$props$initialCo : '',
      translatedPinnedReplyText: (_this$props$initialCo2 = _this.props.initialContent.pinnedReplyText) !== null && _this$props$initialCo2 !== void 0 ? _this$props$initialCo2 : '',
      translatedReplies: convertRepliesToOnDemandTranslationReplies(!!_this.props.threadedRepliesEnabled, _this.props.initialContent.replies),
      translatedReply: (_this$props$initialCo3 = _this.props.initialContent.individualReply) !== null && _this$props$initialCo3 !== void 0 ? _this$props$initialCo3 : ''
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "translateOnlyOneReply", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(selectedLang) {
        var result;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this.setState({
                  isTranslationInProgressForReply: true,
                  isTranslationFailedForReply: false,
                  isPostTranslatedForReply: false,
                  selectedLanguageToTranslate: selectedLang
                });

                _context3.prev = 1;
                _context3.next = 4;
                return (0, _OnDemandTranslations.translateReply)({
                  content: _this.props.initialContent.individualReply,
                  entityType: 'reply',
                  language: selectedLang
                });

              case 4:
                result = _context3.sent;

                if (result) {
                  _this.setState({
                    translatedReply: result.translation,
                    isPostTranslatedForReply: true
                  });
                }

                _this.setState({
                  isTranslationInProgressForReply: false
                });

                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](1);

                _this.setState({
                  isTranslationFailedForReply: true,
                  isTranslationInProgressForReply: false
                });

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 9]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "translateThread", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(selectedLang) {
        var _this$props, threadedRepliesEnabled, initialContent, contentPayload, result, title, topicContent, bestAnswerText, pinnedReplyText, replies;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$props = _this.props, threadedRepliesEnabled = _this$props.threadedRepliesEnabled, initialContent = _this$props.initialContent;

                _this.setState({
                  isTranslationInProgress: true,
                  isTranslationFailed: false,
                  isPostTranslated: false,
                  selectedLanguageToTranslate: selectedLang
                });

                _context4.prev = 2;
                contentPayload = _objectSpread(_objectSpread({}, initialContent), {}, {
                  replies: convertRepliesToOnDemandTranslationPayload(!!threadedRepliesEnabled, initialContent.replies)
                });
                _context4.next = 6;
                return (0, _OnDemandTranslations.translateThread)({
                  content: contentPayload,
                  language: selectedLang,
                  entityType: 'thread'
                });

              case 6:
                result = _context4.sent;
                title = result.title, topicContent = result.topicContent, bestAnswerText = result.bestAnswerText, pinnedReplyText = result.pinnedReplyText, replies = result.replies;

                if (result) {
                  _this.setState({
                    translatedTitle: title,
                    translatedTopicContent: topicContent,
                    translatedBestAnswerText: bestAnswerText,
                    translatedPinnedReplyText: pinnedReplyText,
                    translatedReplies: convertResponseRepliesToOnDemandTranslationReplies(replies),
                    isTranslationInProgress: false,
                    isPostTranslated: true
                  });
                }

                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](2);

                _this.setState({
                  isTranslationFailed: true,
                  isTranslationInProgress: false
                });

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[2, 11]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDemandTranslation", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(selectedLang) {
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!_this.props.shouldTranslateOnlyOneReply) {
                  _context5.next = 4;
                  break;
                }

                _context5.next = 3;
                return _this.translateOnlyOneReply(selectedLang);

              case 3:
                return _context5.abrupt("return", _context5.sent);

              case 4:
                _context5.next = 6;
                return _this.translateThread(selectedLang);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDisplayOriginal", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return new Promise(function (resolve) {
                if (_this.props.shouldTranslateOnlyOneReply) {
                  var _this$props$initialCo4;

                  _this.setState({
                    isTranslationInProgressForReply: false,
                    selectedLanguageToTranslate: null,
                    isPostTranslatedForReply: false,
                    isTranslationFailedForReply: false,
                    translatedReply: (_this$props$initialCo4 = _this.props.initialContent.individualReply) !== null && _this$props$initialCo4 !== void 0 ? _this$props$initialCo4 : ''
                  }, function () {
                    return resolve();
                  });
                } else {
                  var _this$props$initialCo5, _this$props$initialCo6;

                  _this.setState({
                    isTranslationInProgress: false,
                    translatedTitle: _this.props.initialContent.title,
                    translatedTopicContent: _this.props.initialContent.topicContent,
                    translatedBestAnswerText: (_this$props$initialCo5 = _this.props.initialContent.bestAnswerText) !== null && _this$props$initialCo5 !== void 0 ? _this$props$initialCo5 : '',
                    translatedPinnedReplyText: (_this$props$initialCo6 = _this.props.initialContent.pinnedReplyText) !== null && _this$props$initialCo6 !== void 0 ? _this$props$initialCo6 : '',
                    translatedReplies: convertRepliesToOnDemandTranslationReplies(!!_this.props.threadedRepliesEnabled, _this.props.initialContent.replies),
                    selectedLanguageToTranslate: null,
                    isPostTranslated: false,
                    isTranslationFailed: false
                  }, function () {
                    return resolve();
                  });
                }
              });

            case 2:
              return _context6.abrupt("return", _context6.sent);

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    })));
    return _this;
  }

  (0, _createClass2.default)(OnDemandTranslationProvider, [{
    key: "render",
    value: function render() {
      var contextValue = _objectSpread(_objectSpread({}, this.state), {}, {
        onDemandTranslation: this.onDemandTranslation,
        onDisplayOriginal: this.onDisplayOriginal,
        languageList: this.props.languageList
      });

      return (0, _preact.h)(OnDemandTranslationContext.Provider, {
        value: contextValue
      }, this.props.children);
    }
  }]);
  return OnDemandTranslationProvider;
}(_preact.Component);

exports.OnDemandTranslationProvider = OnDemandTranslationProvider;